var _excluded = ["path"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Route as RouteDefault } from 'react-router-dom';
import { setBasenameToPathname } from 'srcJs/helpers/LanguageHelper';

var Route = function Route(_ref) {
  var path = _ref.path,
      props = _objectWithoutProperties(_ref, _excluded);

  var buildPath = function buildPath(pathForBuild) {
    return "/:locale?".concat(setBasenameToPathname(pathForBuild));
  };

  var pathNew;

  if (Array.isArray(path)) {
    pathNew = path.map(function (pathElement) {
      return buildPath(pathElement);
    });
  } else {
    pathNew = buildPath(path);
  } // eslint-disable-next-line react/jsx-props-no-spreading


  return /*#__PURE__*/React.createElement(RouteDefault, _extends({
    path: pathNew
  }, props));
};

export { Route };